import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '_lib/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gridColumnGap: theme.r.mobile.gutter,
    gridRowGap: theme.r.mobile.gutter,

    [theme.r.tablet.up]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },

    [theme.r.desktop.up]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
  },
}));

type Props = {
  children: React.ReactNode;
};

const Grid = (props: Props) => {
  const classes = useStyles();
  const { children } = props;

  return <div className={classes.container}>{children}</div>;
};

export default Grid;
